import React from 'react';
import RelayStore from '../RelayStore'
import ValidateUserMutation from '../mutations/User/ValidateUserMutation';

class CircleTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLine: null
    }
  }

  _highlightLine(index) {
    this.setState({activeLine: index});
  }


  validateUser(user){
    user.isTrustedUserToCreateActivities = true;
    this.onValidateUser(user);
  }

  unvalidateUser(user){
    user.isTrustedUserToCreateActivities = false;
    this.onValidateUser(user);

  }

  onValidateUser = (user) => {
    const viewer = this.props.viewer;
    let validatePublicActivities = user.isTrustedUserToCreateActivities;
    let validatePublicGroups = user.isTrustedUserToCreateCircles;

	let mutation = new ValidateUserMutation({viewer, user, validatePublicActivities, validatePublicGroups});

  	RelayStore.commitUpdate( mutation, {
		onFailure: (error) => {
			console.log('error', error.getError());
			alert('Update Failed');
		},
		onSuccess: (response) => {
			console.log('success', response);
			alert('Update Success');
		}
  	});
  }

  _switchButton(user){
    if(!user.isTrustedUserToCreateCircles){
      return <button type="button" className="btn btn-success btn-sm" onClick={() => {this.validateUser(user)}}>Validate user</button>

    }
    else{
      return <button type="button" className="btn btn-danger btn-sm" onClick={() => {this.unvalidateUser(user)}}>unvalidate user</button>

    }
  }

  _renderItem(item, index){

    const { name, creation_status, owner, mode, type, publicShortCode } = item;
    const status = creation_status.status;
    //const ownerPseudo = owner.pseudo;
    
    let activeClass = (this.state.activeLine == index) ? 'active' : null;
      
    return (
      <tr className={activeClass}
        key={index}
       >
          <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>{index}</td>
          <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>{name}</td>
          {/* <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>{ownerPseudo}</td> */}
          <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>{mode}</td>
          <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>{status}</td>
          <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>{type}</td>
          <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>{publicShortCode}</td>
          <td onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}><button type="button" className="btn btn-danger btn-sm" onClick={(event) => this.props.onEditItemClick(item.node, index, event)}>Modify</button></td>
      </tr>
    )
  }
 // <button type="button" className="btn btn-success btn-sm" onClick={this.onValidatePublicActivitiesClick.bind(this)}>Validate user</button>
  render() {
    const dataSource = this.props.dataSource;
    return (
      <table className="table table-hover table-condensed">
        <thead>
          <tr>
            <th>NO.</th>
            <th>Name</th>
            {/* <th>Owner</th>             */}
            <th>Mode</th>
            <th>Status</th>
            <th>Type</th>
            <th>Public Short Code</th>
          </tr>
        </thead>

        <tbody>
          {dataSource.map((item, index, arr) => this._renderItem(item.node, index))}
        </tbody>
      </table>
    )
  }


}

CircleTable.propTypes = ({
  dataSource : React.PropTypes.array.isRequired,
  onItemClick: React.PropTypes.func.isRequired,
});




export default CircleTable;


// WEBPACK FOOTER //
// ./src/components/CircleTable.js